import axios from "axios";
import { API, BASE_API } from "../../const";
import { normParam } from "../../tools";
const M_API = API;

const store = {
  namespaced: true,
  state: {
    informasi: null
  },
  getters: {
    informasi(state) {
      return state.informasi;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { params }) {
      return axios
        .get(`${M_API}/m_informasi${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    form(_, { obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/m_informasi/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/m_informasi`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    setBaca(_, obj) {
      return axios
        .post(`${BASE_API}/gtk/update_is_baca`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/m_informasi/${item.id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    publish({}, obj) {
      obj.status = 1;
      return axios
        .put(`${M_API}/m_informasi/${obj.id}`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    unpublish({}, obj) {
      obj.status = 0;
      return axios
        .put(`${M_API}/m_informasi/${obj.id}`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detail(_, { informasi_id }) {
      return axios
        .get(`${M_API}/m_informasi/${informasi_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    }
  }
};

export default store;
